import { useContext } from "react";

import useWS from "../../hooks/useWS";
import { useGlobal } from "../globalContext";

export default function useIOWS({ IOWSEnabledForDebugging, userHasControlOfCurrentScreen, wsRef, IOType }) {
  const { SCREEN_STATE } = useGlobal();

  const currentScreen = SCREEN_STATE?.screens?.find((x) => x.id === SCREEN_STATE?.currentScreen?.id);
  const wsUrlTemplate = currentScreen?.io_ws_path_template || "";
  const wsUrl = wsUrlTemplate.replace("TYPE", IOType);
  const { send } = useWS(wsRef, IOWSEnabledForDebugging && userHasControlOfCurrentScreen && wsUrl);
  return { send };
}
